export enum PaymentType {
  FIAT = 'fiat',
  CRYPTO = 'crypto',
  ON_RAMP = 'onRamp',
}
